import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import auth from './authReducer'
import quickStart from './quickStart'
import apartmentModal from './apartmentModal'
import announcements from './announcementState'
import threads from './threadsState'
import contactModal from './contactModalState'
import confirmationModal from './confirmationModalState'
import moveOut from './moveOutState'
import templates from './templateState'
import contacts from './contactState'
import contactCompModal from './ContactCompModalState'
import loader from './loaderState'
import toast from './toast'

export default combineReducers({
  auth,
  quickStart,
  apartmentModal,
  announcements,
  threads,
  contactModal,
  confirmationModal,
  moveOut,
  templates,
  contacts,
  contactCompModal,
  loader,
  form: formReducer,
  toast,
})
